import React, { MutableRefObject, useEffect, useRef, useState } from 'react'
import styles from "../../styles/components/GroupDropdown.module.scss";
import { filterObjectsByValue } from '../../functions/general/filter';
import { useOnClickOutside } from "@qastanfit/qastan-ui";

type ListItem = {
    parent: string;
    children: Array<string>;
}

const example = [
    {
        parent: 'Documentatie',
        children: ['1_DRP document', '2_Project documentatie', '3_Technisch Document']
    },
    {
        parent: 'Administratie',
        children: ['4_Aankooporder leverancier', '5_Offerte', '6_Bestelling klant', '7_Leveranciersofferte']
    },
    {
        parent: 'HR-Groep',
        children: ['8_HR', '9_Sollicitant', '10_SD Worx Doc']
    }
]

type Props = {
    onChange: (v:string) => void;
    list: ListItem[]
    clearOnSelect?: boolean;
    placeholder?: string;
}

function GroupDropdown({onChange, list, clearOnSelect, placeholder="Placeholder..."} : Props) {
    const inputRef = useRef() as MutableRefObject<HTMLInputElement>
    const dropdownRef = useRef() as MutableRefObject<HTMLDivElement>

    const [main_list, setmain_list] = useState<ListItem[]>();
    const [filtered_list, setfiltered_list] = useState<ListItem[]>();
    
    const [isOpened, setisOpened] = useState(false);

    useEffect(()=>{
        if(list){
            setmain_list(list);
            setfiltered_list(list);
        }
    }, [list])

    useOnClickOutside(dropdownRef, () => { if(isOpened){ setisOpened(false)} })

    const searchItem = (value:string) => {
        if(main_list){
            const v = filterObjectsByValue([...main_list], value) as ListItem[]
            setfiltered_list(v)
        }
    }

    const selectItem = (value:string) => {
        if(clearOnSelect){
            inputRef.current.value = '';
        }
        else {
            inputRef.current.value = value.split(';')[1]
        }

        onChange(value);
        setisOpened(false);
    }

    const selectParent = (value:ListItem) => {
        value.children.forEach(child => {
            selectItem(child)
        });
    }

    return (
    <div ref={dropdownRef} className={styles.groupdropdown}>
        <div className={`${styles.input_ct} bg-white border rounded-md`}>
            <input onFocus={()=>{setisOpened(true)}} onChange={(e:React.ChangeEvent<HTMLInputElement>)=>{searchItem(e.currentTarget.value)}} className='w-full bg-transparent px-3 h-10 focus:outline-none' ref={inputRef} placeholder={placeholder}/>
            <button onClick={()=>{inputRef.current.focus()}} className={styles.arrow}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg></button>
        </div>
        <div className={`${!isOpened && styles.list_hidden} ${styles.list}`}>
            {filtered_list && filtered_list.map((listitem, index) => {
                return (
                    <div className={styles.sublist} key={index}>
                        <button onClick={()=>{selectParent(listitem)}} className={styles.parent_option}>{listitem.parent}</button>
                        {listitem.children.map((child, ind) => {
                            return (
                                <button onClick={()=>{selectItem(child)}} className={styles.option} key={ind}>{child.split(';')[1]}</button>
                            )
                        })}
                    </div>
                )
            })}
        </div>
    </div>
    )
}

export default GroupDropdown